module.exports = __webpack_public_path__ + "img/1.9f1a9b91.png";